import React, { useRef } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ReactDOM from 'react-dom';
import staticMasterJson from "../../src/json-data/generalinformationdata.json";
import MainDataJson from "../../src/json-data/generalinfomaindata.json";
// import GlassBoxData from "../../src/json-data/glassboxdata.json";
import glassboximg from '../assets/img/glassbox empty.svg'
import { VscCommentUnresolved } from "react-icons/vsc";
import { useState, useEffect, Fragment } from "react";
import { Container, lightColors, Button, darkColors, Link } from 'react-floating-action-button'
import * as AWS from 'aws-sdk';

// import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Modal from 'react-bootstrap/Modal';
//import { Container, Button, lightColors, darkColors, Link } from 'react-floating-action-button'
import 'font-awesome/css/font-awesome.min.css';
import GlassBox from './glassbox';
import DataTable from 'react-data-table-component';
import { Popover, OverlayTrigger, Form } from 'react-bootstrap';
import GeneralInformationHeader from './dg-general-info-header';
import GeneralInformationGraph from './dg-general-info-graph';
import GeneralInformationAssetsTab from './dg-general-info-assets-tab';
import GeneralInformationIncomeTab from './dg-general-info-income-tab';
import GeneralInformationCreditTab from './dg-general-info-credit-tab';
import GeneralInformationCollateralTab from './dg-general-info-collateral-tab';
import GeneralInformationOthersTab from './dg-general-info-others-tab';
import DocumentTreeView from './New-window/documen-treeview';
import UseLambdaInvocations from '../hooks/useLambdaInvocations';
import lambdaConfig from '../hooks/lambdaConfig';
import { configData } from "../config/systemconfigurationconstants";
import { ToastContainer, toast } from "react-toastify";
import { useEncryption } from '../customHooks/useEncryption';
import { useNavigate } from 'react-router-dom';
const GeneralInformation = () => {
   const { encrypt, decrypt } = useEncryption();
   const getCookie = (name) => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) {
         return decodeURIComponent(parts.pop().split(';').shift());
      }
      return null;
   };
   const popupRef = useRef(null);
   const navigate = useNavigate();
   const { invokeLambda, loading, error } = UseLambdaInvocations();
   const [loaninfoheader, setLoaninfoheader] = useState([]);
   const [loaninfograph, setLoaninfograph] = useState([]);
   const [loaninfo, setLoaninfo] = useState('');
   const [loanExport, setLoanExport] = useState('');
   const [LoanStatus, setLoanStatus] = useState('');
   const [ApprovalStatus, setApprovalStatus] = useState('');
   const [GlassBoxData, setGlassboxData] = useState();
   const [dotloader, setDotLoader] = useState(false);
   const [activeTab, setActiveTab] = useState('');
   const [idxLoanGuid, setIdxLoanGuid] = useState();
   const [idxUserName, setIdxUserName] = useState(''); //DGV2-575
   const [idxPassword, setIdxPassword] = useState(''); //DGV2-575
   const [userRights] = useState(JSON.parse(localStorage.getItem("UserRights")));
   const [rolesAndRights] = useState(JSON.parse(localStorage.getItem("RolesAndRights")));
   const lambda = new AWS.Lambda({
      region: configData.LAMBDA_REGION,
      accessKeyId: decrypt(getCookie('ak')),
      secretAccessKey: decrypt(getCookie('sk'))
   });
   const [conditionjson, setConditionJson] = useState({
      "LoanGuid": localStorage.getItem("loanGuid"),
      "Action": "Clear",
      "Details": []
   });
   const tabIds = [
      'pills-decisiondashboard',
      'pills-assets',
      'pills-income',
      'pills-credit',
      'pills-collateral',
      'pills-others',
   ];
   const tabDisplayNames = {
      'pills-decisiondashboard': 'Decision Dashboard',
      'pills-assets': 'Assets',
      'pills-income': 'Income',
      'pills-credit': 'Credit',
      'pills-collateral': 'Collateral',
      'pills-others': 'Others',
   };
   // Effect to read the active tab from local storage
   useEffect(() => {
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      console.log(timeZone, 'timeZonetimeZone')
      const storedTab = localStorage.getItem('activeTab');
      if (storedTab) {
         setActiveTab(storedTab);
      } else {
         // Set a default tab if none is stored
         setActiveTab(tabIds[0]);
      }
   }, []);

   // Function to handle tab change
   const handleTabChange = (tabId) => {
      setActiveTab(tabId);
      localStorage.setItem('activeTab', tabId); // Store the active tab in local storage
   };
   useEffect(() => {
      getGeneralInfoForLoan();
      getGeneralInfoDetailsForLoan();
      // setLoaninfoheader(MainDataJson.LoanInfoFields);
      // setLoaninfograph(MainDataJson.GeneralInfo);
   }, [])
   const getGeneralInfoForLoan = async () => {
      setDotLoader(false);
      try {
         const parsedBody = await invokeLambda(configData.GET_GENERAL_INFO_FOR_LOAN, {
            ...lambdaConfig,
            SecurityToken: localStorage.getItem('SecurityToken'),
            "LoanGuid": localStorage.getItem('loanGuid'),
         });
         // if (Array.isArray(parsedBody.Output.impdata)) {
         if (parsedBody.Status) {
            setLoaninfoheader(parsedBody.UIfields[0].LoanInfoFields)
            setLoaninfograph(parsedBody.UIfields[0].GeneralInfo);
            setLoaninfo(parsedBody.UIfields[0].DecisionIndicator)
            setLoanExport(parsedBody.UIfields[0].LoanExportStatus)
            setLoanStatus(parsedBody.UIfields[0].LoanStatus)
            setApprovalStatus(parsedBody.UIfields[0].ApprovalStatus)
            setIdxLoanGuid(parsedBody.UIfields[0].IDXLoanGuid)
            setIdxUserName(encrypt(base64ToString(parsedBody.DIU))); //DGV2-575
            setIdxPassword(encrypt(base64ToString(parsedBody.DIP))); //DGV2-575
            setTimeout(() => {
               setDotLoader(true);
            }, 1000);
         } else {
            setDotLoader(false);
         }
      } catch (err) {
         // Handle error if needed
         setDotLoader(false);

      }
   }
   /*DGV2-575*/
   function base64ToString(val) {
      const binary = atob(val);
      const len = binary.length;
      const bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i);
      return new TextDecoder('utf-8').decode(bytes);
   }
   /*DGV2-575*/
   const getGeneralInfoDetailsForLoan = async () => {
      setDotLoader(false);
      try {
         const parsedBody = await invokeLambda(configData.GET_GENERAL_INFO_DETAILS_FOR_LOAN, {
            ...lambdaConfig,
            SecurityToken: localStorage.getItem('SecurityToken'),
            "LoanGuid": localStorage.getItem('loanGuid'),
         });
         // if (Array.isArray(parsedBody.Output.impdata)) {
         if (parsedBody.Status) {
            localStorage.setItem('glassboxjson', JSON.stringify(parsedBody));
            setGlassboxData(parsedBody)
            setTimeout(() => {
               setDotLoader(true);
            }, 1000);
            setConditionJson(prevState => ({
               ...prevState,
               Details: []
            }));
         } else {
            setDotLoader(false);

         }
      } catch (err) {
         setDotLoader(false);

         // Handle error if needed
      }
   }
   const amount = staticMasterJson.UIData[0][0].LoanAmount;
   console.log(amount)
   const checkPopupInterval = useRef(null);

   const clearLocalStorageKeys = () => {
      // Clear only the specific keys
      localStorage.removeItem('DGV2_LoanGuid')
      localStorage.removeItem('DGV2_Loansts')
      localStorage.removeItem('DGV2_SourceName')
      localStorage.removeItem('DGV2_UserMappingData');
      localStorage.removeItem('DGV2_UserName');
      localStorage.removeItem('DGV2_SecurityToken');
      localStorage.removeItem('DGV2_Role');
      localStorage.removeItem('DGV2_ExternalId');
      localStorage.removeItem('DGV2_CurrentMapping');
      localStorage.removeItem('DGV2_UseCaseShortName')
      localStorage.removeItem('DGV2_ClientShortName')
      localStorage.removeItem('DGV2_ClientShortName')
      console.log('Cleared specific localStorage keys on popup close.');
   };
   const openDocumentTreeViewInNewWindow = () => {

      const loanguid = idxLoanGuid; // Replace this with your actual value
      const username = localStorage.getItem('UserName')
      // const baseUrl = 'http://localhost:3001/dgtreeview';
      const baseUrl = configData.NEWIDXDEVURL;

      // Check if URL already has query parameters
      const separator = baseUrl.includes('?') ? '&' : '?';
      /*//DGV2-575 -added two additional query parameter to popup url */
      const popupUrl = `${baseUrl}${separator}loanguid=${encodeURIComponent(loanguid)}&username=${encodeURIComponent(username)}&diu=${encodeURIComponent(idxUserName)}&dip=${encodeURIComponent(idxPassword)}`;

      const windowName = 'myUniquePopupWindow';
      const features = 'width=1000,height=800,left=200,top=200';

      if (!popupRef.current || popupRef.current.closed) {
         popupRef.current = window.open(popupUrl, windowName, features);
         // Start polling to detect when the popup is closed
         checkPopupInterval.current = setInterval(() => {
            if (popupRef.current && popupRef.current.closed) {
               clearInterval(checkPopupInterval.current);
               checkPopupInterval.current = null;
               clearLocalStorageKeys();
            }
         }, 500);
      } else {
         popupRef.current.focus();
      }

   };
   useEffect(() => {
      // Cleanup interval if component unmounts
      return () => {
         if (checkPopupInterval.current) {
            clearInterval(checkPopupInterval.current);
         }
      };
   }, []);
   const [newWindow, setNewWindow] = useState(null);
   const openUrl = (output) => {
      let defaultMapping = {};
      if (output.MappingInfo != null && output.MappingInfo.length > 0) {
         defaultMapping = output.MappingInfo.find(el => el.IsDefault === true) || {};
      }

      const popupUrl = configData.NEWIDXDEVURL;
      const windowName = 'myUniquePopupWindow';
      const features = 'width=1000,height=800,left=200,top=200';

      if (!popupRef.current || popupRef.current.closed) {
         popupRef.current = window.open(popupUrl, windowName, features);
      } else {
         popupRef.current.focus();
      }

      // Prepare the data you want to send to the popup
      const data = {
         LoanGuid: output.LoanGuId,
         Loansts: output.LoanStatus,
         SourceName: 'DGV2',
         UserMappingData: output.MappingInfo,
         UserName: "DGIDXGenius",
         SecurityToken: output.Token,
         Role: defaultMapping.RoleName,
         ExternalId: defaultMapping.ClientId,
         CurrentMapping: defaultMapping,
         UseCaseShortName: defaultMapping.UCSN,
         ClientShortName: defaultMapping.CSN,
         getconfigforthumbprev: "False"

      };

      // Send the data to the popup window after it has had a chance to load
      setTimeout(() => {
         popupRef.current?.postMessage(
            { type: 'SET_LOCAL_STORAGE', data },
            configData.NEWIDXDEVURL
         );
      }, 1000);
      // If window already open and not closed, just focus it
      // const url = 'http://localhost:3001/';
      // const windowName = 'myUniquePopupWindow';
      // const windowFeatures = 'width=1000,height=800,left=200,top=200';

      // // If popup is already open, just focus it
      // if (popupRef.current && !popupRef.current.closed) {
      //    popupRef.current.focus();
      // } else {
      //    // Open the popup and store the reference
      //    const newPopup = window.open(url, windowName, windowFeatures);

      //    if (newPopup) {
      //       popupRef.current = newPopup;

      //       // Optional: send data after window loads (can also use setTimeout as fallback)
      //       newPopup.onload = () => {
      //          try {
      //             newPopup.localStorage.setItem('myKey', 'someValue');
      //          } catch (err) {
      //             console.warn('Cannot access localStorage in popup (possibly cross-origin).');
      //          }
      //       };
      //    } else {
      //       alert('Popup was blocked. Please allow popups for this site.');
      //    }
      // }

      // const features = 'width=800,height=600,left=200,top=200'; // Customize as needed

      // if (newWindow && !newWindow.closed) {
      //    try {
      //       newWindow.location.reload();
      //       newWindow.focus();
      //    } catch (error) {
      //       console.error("Error reloading window:", error);
      //       // Optionally, you can reopen the window if reload fails
      //       newWindow = window.open(url, '_blank', features);
      //    }
      // } else {
      //    newWindow = window.open(url, '_blank', features);
      // }
      // // Set local storage items
      // localStorage.setItem("LoanGuid", output.LoanGuId);
      // localStorage.setItem("Loansts", output.LoanStatus);
      // localStorage.setItem("SourceName", "DG");
      // localStorage.setItem("User  MappingData", JSON.stringify(output.MappingInfo));
      // localStorage.setItem("User  Name", 'srinivas');
      // localStorage.setItem("SecurityToken", output.Token);

      // let defaultMapping = {};
      // if (output.MappingInfo != null && output.MappingInfo.length > 0) {
      //    defaultMapping = output.MappingInfo.find(el => el.IsDefault === true);
      // }
      // localStorage.setItem("Role", defaultMapping.RoleName);
      // localStorage.setItem("ExternalId", defaultMapping.ClientId);
      // localStorage.setItem("CurrentMapping", JSON.stringify(defaultMapping));
      // localStorage.setItem("UseCaseShortName", defaultMapping.UCSN);
      // localStorage.setItem("ClientShortName", defaultMapping.CSN);

      // Construct the URL with query parameters
      // const url = new URL('http://mil-og-gdx-web-host.s3-website-us-west-2.amazonaws.com/docscreening');
      // url.searchParams.append('LoanGuid', output.LoanGuId);
      // url.searchParams.append('LoanStatus', output.LoanStatus);
      // url.searchParams.append('SourceName', 'DG');
      // url.searchParams.append('User Name', 'srinivas');
      // url.searchParams.append('SecurityToken', output.Token);
      // url.searchParams.append('Role', defaultMapping.RoleName);
      // url.searchParams.append('ExternalId', defaultMapping.ClientId);
      // url.searchParams.append('UseCaseShortName', defaultMapping.UCSN);
      // url.searchParams.append('ClientShortName', defaultMapping.CSN);

      // Open the new window with the constructed URL
      // const windowFeatures = 'width=800,height=600,resizable=yes,scrollbars=yes,status=yes';
      // const newWindow = window.open(url.toString(), '_blank', windowFeatures);

      // Optionally, you can check if the new window is opened successfully
      // if (newWindow) {
      //    newWindow.focus(); // Bring the new window to the front
      // } else {
      //    console.error("Failed to open new window. Please check your browser settings.");
      // }
   };
   const clearLosFlag = async () => {
      let disabledinvocation = false;
      if (disabledinvocation) {
         try {
            const parsedBody = await invokeLambda(configData.RESET_LOS_FLAG, {
               ...lambdaConfig,
               SecurityToken: localStorage.getItem('SecurityToken'),
               "LoanGuid": localStorage.getItem('loanGuid'),
            });
            if (parsedBody.Status) {
               toast.success("Los Flag Cleared Sucessfully", {
                  position: "bottom-center",
                  autoClose: 2000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
               });
            } else {
               toast.error("Los Flag Not Cleared Sucessfully", {
                  position: "bottom-center",
                  autoClose: 2000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
               });
            }
         } catch (err) {
            // Handle error if needed
         }
      }
   }
   const printDgResults = async () => {
      setDotLoader(false)
      const data = {
         Command: configData.PRINT_DG_RESULTS,
         UserName: localStorage.getItem('UserName'),
         TimeZone: "India Standard Time",
         ClientShortName: localStorage.getItem('ClientShortName').trim(),
         UseCaseShortName: localStorage.getItem('UseCaseShortName').trim(),
         SecurityToken: localStorage.getItem("SecurityToken"),
         LoanGuid: localStorage.getItem('loanGuid'),
         SecurityId: null,
         EventContextId: null,
         CallerSourceId: null,
         CallerSourceName: null,
      };
      const params = {
         FunctionName: configData.LAMBDA_FUNCTION_NAME1,
         Payload: JSON.stringify(data)
      };

      lambda.invoke(params, (err, data) => {
         if (err) {
            console.log(err, err.stack);
         } else {
            let lambdaResponse = JSON.parse(data.Payload.toString());
            const parsedBody = JSON.parse(lambdaResponse.body);
            if (parsedBody.Status === true) {
               // Set AWS credentials
               AWS.config.credentials = new AWS.Credentials({
                  accessKeyId: decrypt(getCookie('ak')),
                  secretAccessKey: decrypt(getCookie('sk'))
               });

               const params = {
                  Bucket: parsedBody.Output.Bucket,
                  Key: parsedBody.Output.FileLocation,
                  Expires: 300 // The URL will now expire in 5 minutes (300 seconds)
               };

               // Create a new S3 instance
               const s3 = new AWS.S3({
                  region: 'us-east-1',
               });

               try {
                  // Generate the signed URL
                  const url = s3.getSignedUrl('getObject', params);

                  // Open the signed URL in a new tab
                  window.open(url, '_blank');
                  toast.success("Report Downloaded Successfully", {
                     position: "bottom-center",
                     autoClose: 2000,
                     hideProgressBar: true,
                     closeOnClick: true,
                     pauseOnHover: true,
                     draggable: true,
                     progress: undefined,
                     theme: "colored",
                  });
                  setTimeout(() => {
                     setDotLoader(true);
                  }, 1000);
               } catch (error) {
                  // Handle errors during URL generation
                  toast.error("Error generating signed URL", {
                     position: "bottom-center",
                     autoClose: 2000,
                     hideProgressBar: true,
                     closeOnClick: true,
                     pauseOnHover: true,
                     draggable: true,
                     progress: undefined,
                     theme: "colored",
                  });
                  console.error('Error generating signed URL:', error);
                  setTimeout(() => {
                     setDotLoader(true);
                  }, 1000);
                  // alert('Failed to generate download link. Please try again later.');
               }
            } else {
               toast.error("Error in downloading report", {
                  position: "bottom-center",
                  autoClose: 2000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
               });
               setTimeout(() => {
                  setDotLoader(true);
               }, 1000);
               // Handle the case where the status is not true
               console.error('Invalid response status:', parsedBody.Status);
               // alert('Failed to retrieve file information. Please check the response.');
            }

         }
      });

   }
   const printIncomeWorkSheet = async () => {
      setDotLoader(false);
      const data = {
         Command: configData.PRINT_WAGE_EARNER,
         UserName: localStorage.getItem('UserName'),
         TimeZone: "India Standard Time",
         ClientShortName: localStorage.getItem('ClientShortName').trim(),
         UseCaseShortName: localStorage.getItem('UseCaseShortName').trim(),
         SecurityToken: localStorage.getItem("SecurityToken"),
         LoanGuid: localStorage.getItem('loanGuid'),
         SecurityId: null,
         EventContextId: null,
         CallerSourceId: null,
         CallerSourceName: null,
      };
      const params = {
         FunctionName: configData.LAMBDA_FUNCTION_NAME1,
         Payload: JSON.stringify(data)
      };

      lambda.invoke(params, (err, data) => {
         if (err) {
            console.log(err, err.stack);
         } else {
            let lambdaResponse = JSON.parse(data.Payload.toString());
            const parsedBody = JSON.parse(lambdaResponse.body);
            if (parsedBody.Status === true) {
               // Set AWS credentials
               AWS.config.credentials = new AWS.Credentials({
                  accessKeyId: decrypt(getCookie('ak')),
                  secretAccessKey: decrypt(getCookie('sk'))
               });

               const params = {
                  Bucket: parsedBody.Output.Bucket,
                  Key: parsedBody.Output.FileLocation,
                  Expires: 300 // The URL will now expire in 5 minutes (300 seconds)
               };

               // Create a new S3 instance
               const s3 = new AWS.S3({
                  region: 'us-east-1',
               });

               try {
                  // Generate the signed URL
                  const url = s3.getSignedUrl('getObject', params);

                  // Open the signed URL in a new tab
                  window.open(url, '_blank');
                  toast.success("Report Downloaded Successfully", {
                     position: "bottom-center",
                     autoClose: 2000,
                     hideProgressBar: true,
                     closeOnClick: true,
                     pauseOnHover: true,
                     draggable: true,
                     progress: undefined,
                     theme: "colored",
                  });
                  setTimeout(() => {
                     setDotLoader(true);
                  }, 1000);
               } catch (error) {
                  // Handle errors during URL generation
                  toast.error("Error generating signed URL", {
                     position: "bottom-center",
                     autoClose: 2000,
                     hideProgressBar: true,
                     closeOnClick: true,
                     pauseOnHover: true,
                     draggable: true,
                     progress: undefined,
                     theme: "colored",
                  });
                  console.error('Error generating signed URL:', error);
                  // alert('Failed to generate download link. Please try again later.');
               }
            } else {
               setTimeout(() => {
                  setDotLoader(true);
               }, 1000);
               toast.error("Error in downloading report", {
                  position: "bottom-center",
                  autoClose: 2000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
               });
               // Handle the case where the status is not true
               console.error('Invalid response status:', parsedBody.Status);
               // alert('Failed to retrieve file information. Please check the response.');
            }

         }
      });
   }
   const manualexport = async () => {
      if (localStorage.getItem("loanStatusofLoan") === "Published") {
         setDotLoader(false);
         try {
            const parsedBody = await invokeLambda(configData.PUBLISH_RESULTS, {
               ...lambdaConfig,
               SecurityToken: localStorage.getItem('SecurityToken'),
               "LoanGuid": localStorage.getItem('loanGuid'),
               "ClientShortName": localStorage.getItem('ClientShortName'),
               "UseCaseShortName": localStorage.getItem('UseCaseShortName')
            });
            if (parsedBody.Status) {
               toast.success("Manual export successfull", {
                  position: "bottom-center",
                  autoClose: 2000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
               });
               setTimeout(() => {
                  setDotLoader(true);
               }, 1000);
            } else {
               toast.error("Manual export Failed", {
                  position: "bottom-center",
                  autoClose: 2000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
               });
               setTimeout(() => {
                  setDotLoader(true);
               }, 1000);
            }

         } catch (err) {
            // Handle error if needed
         }
      }

   }

   const hasRightsToDGResultsPDF = () => {

      if (rolesAndRights !== null) {

         let rightID = rolesAndRights.AllRights.find(el => el.RightType.trim() == "DG_RESULTS_PDF")?.RightId;

         if (userRights.some(el => el.RightId == rightID)) {

            return userRights.find(el => el.RightId == rightID).RightValue == 1 ? true : false;

         }

      }

   }



   const hasRightsToDocumentTree = () => {

      if (rolesAndRights !== null) {

         let rightID = rolesAndRights.AllRights.find(el => el.RightType.trim() == "DOCUMENT_TREE")?.RightId;

         if (userRights.some(el => el.RightId == rightID)) {

            return userRights.find(el => el.RightId == rightID).RightValue == 1 ? true : false;

         }

      }

   }



   const hasRightsToPrintIncWorksheet = () => {

      if (rolesAndRights !== null) {

         let rightID = rolesAndRights.AllRights.find(el => el.RightType.trim() == "PRINT_INC_WORKSHEET")?.RightId;

         if (userRights.some(el => el.RightId == rightID)) {

            return userRights.find(el => el.RightId == rightID).RightValue == 1 ? true : false;

         }

      }

   }



   const hasRightsToExport = () => {

      if (rolesAndRights !== null) {

         let rightID = rolesAndRights.AllRights.find(el => el.RightType.trim() == "EXPORT")?.RightId;

         if (userRights.some(el => el.RightId == rightID)) {

            return userRights.find(el => el.RightId == rightID).RightValue == 1 ? true : false;

         }

      }

   }

   useEffect(() => {
      document.body.classList.add('no-scroll');
      return () => document.body.classList.remove('no-scroll');
   }, []);
   return (
      <Fragment>
         <Header />

         {dotloader ? (<div className='container-fluid' style={{ marginTop: '50px' }}>
            <Container>
               {hasRightsToDocumentTree() && (<Link tooltip="DOCUMENT TREE">
                  <div onClick={openDocumentTreeViewInNewWindow}><i style={{ cursor: 'pointer' }} className='ri-node-tree'></i></div>
               </Link>)}
               {hasRightsToPrintIncWorksheet() && (<Link tooltip="PRINT INC WORKSHEET">
                  <div onClick={printIncomeWorkSheet}><i style={{ cursor: 'pointer' }} className='ri-printer-cloud-line'></i></div>
               </Link>)}
               {hasRightsToDGResultsPDF() && (<Link tooltip="PRINT RESULTS">
                  <div onClick={printDgResults}><i style={{ cursor: 'pointer' }} className='ri-printer-cloud-line'></i></div>
               </Link>)}
               {hasRightsToExport() && (<Link tooltip="EXPORT"><div style={{
                  opacity: localStorage.getItem("loanStatusofLoan") === "Published" ? 1 : 0.5,
                  cursor: localStorage.getItem("loanStatusofLoan") === "Published" ? 'default' : 'not-allowed'
               }} onClick={manualexport}><i className='ri-download-cloud-2-line'></i></div></Link>)}
               <Link tooltip="CLEAR LOS FLAGS"><div style={{ opacity: 0.5, cursor: 'not-allowed' }} onClick={clearLosFlag}><i className='ri-file-close-line'></i></div></Link>

               {/* <Link href="#"><i class="ri-node-tree me-2"></i> DOCUMENT TREE</Link>
               <Link href="#"><i class="ri-printer-cloud-line me-2"></i> PRINT INC WORKSHEET</Link> */}
               <Button
                  styles={{ backgroundColor: darkColors.lighterRed, color: lightColors.white }}
                  icon="ri-add-line fs-5"
                  rotate={true}
               />
            </Container>
            <div className='row'>
               <div className='col-sm-12 general-info-pagescroll'>
                  {loaninfoheader.length > 0 && <GeneralInformationHeader loaninfoheaders={loaninfoheader} LoanInfo={loaninfo} LoanExport={loanExport} LoanStatus={LoanStatus} ApprovalStatus={ApprovalStatus} />}
                  <div className="general-info-card">
                     <div className="card p-2">
                        <div class="card-header p-0">
                           <ul className="nav nav-tabs nav-justified1 tab-style-4 mb-0 pt-1 pb-1" id="pills-tab" role="tablist">
                              {tabIds.map((tabId) => (
                                 <li className="nav-item" role="presentation" key={tabId}>
                                    <button
                                       className={`nav-link ${activeTab === tabId ? 'active' : ''} px-3`}
                                       id={`${tabId}-tab`}
                                       data-bs-toggle="pill"
                                       data-bs-target={`#${tabId}`}
                                       type="button"
                                       role="tab"
                                       aria-controls={tabId}
                                       aria-selected={activeTab === tabId}
                                       onClick={() => handleTabChange(tabId)} // Handle tab change
                                    >
                                       {/* {tabId.replace('pills-', '').charAt(0).toUpperCase() + tabId.slice(7)} */}
                                       {tabDisplayNames[tabId]}
                                    </button>
                                 </li>
                              ))}
                           </ul>
                        </div>
                        <div className="card-body p-0 general-info-tabs">
                           <div class="tab-content" id="pills-tabContent">
                              <div className={`tab-pane fade ${activeTab === 'pills-decisiondashboard' ? 'show active' : ''}`} id="pills-decisiondashboard" role="tabpanel" aria-labelledby="pills-decisiondashboard-tab" tabIndex="0" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                 {loaninfograph?.length > 0 && <GeneralInformationGraph loaninfographs={loaninfograph} />}
                              </div>
                              <div className={`tab-pane fade ${activeTab === 'pills-assets' ? 'show active' : ''}`} id="pills-assets" role="tabpanel" aria-labelledby="pills-assets-tab" tabIndex="0">
                                 <GeneralInformationAssetsTab LoanStatus={LoanStatus} GlassBoxDatas={GlassBoxData} getGeneralInfoDetailsForLoan={getGeneralInfoDetailsForLoan} conditionjson={conditionjson}
                                    setConditionJson={setConditionJson} />
                              </div>
                              <div className={`tab-pane fade ${activeTab === 'pills-income' ? 'show active' : ''}`} id="pills-income" role="tabpanel" aria-labelledby="pills-income-tab" tabIndex="0">
                                 <GeneralInformationIncomeTab LoanStatus={LoanStatus} GlassBoxDatas={GlassBoxData} getGeneralInfoDetailsForLoan={getGeneralInfoDetailsForLoan} conditionjson={conditionjson}
                                    setConditionJson={setConditionJson} />
                              </div>
                              <div className={`tab-pane fade ${activeTab === 'pills-credit' ? 'show active' : ''}`} id="pills-credit" role="tabpanel" aria-labelledby="pills-credit-tab" tabIndex="0">
                                 <GeneralInformationCreditTab LoanStatus={LoanStatus} GlassBoxDatas={GlassBoxData} getGeneralInfoDetailsForLoan={getGeneralInfoDetailsForLoan} conditionjson={conditionjson}
                                    setConditionJson={setConditionJson} />
                              </div>
                              <div className={`tab-pane fade ${activeTab === 'pills-collateral' ? 'show active' : ''}`} id="pills-collateral" role="tabpanel" aria-labelledby="pills-collateral-tab">
                                 <GeneralInformationCollateralTab LoanStatus={LoanStatus} GlassBoxDatas={GlassBoxData} getGeneralInfoDetailsForLoan={getGeneralInfoDetailsForLoan} conditionjson={conditionjson}
                                    setConditionJson={setConditionJson} />
                              </div>
                              <div className={`tab-pane fade ${activeTab === 'pills-others' ? 'show active' : ''}`} id="pills-others" role="tabpanel" aria-labelledby="pills-others-tab" tabIndex="0">
                                 <GeneralInformationOthersTab LoanStatus={LoanStatus} GlassBoxDatas={GlassBoxData} getGeneralInfoDetailsForLoan={getGeneralInfoDetailsForLoan} conditionjson={conditionjson}
                                    setConditionJson={setConditionJson} />
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div></div>
         </div>) : (
            <div style={{ marginTop: "20%", marginBottom: "20%" }} className="d-flex justify-content-center">
               <div className="loader"></div>
            </div>
         )}
         <Footer />





      </Fragment>
   );
}
export default GeneralInformation;